import $ from '../jquery-shim.js';

export function ajaxAddToCartHandler() {

   $('.product-small.swiper-slide').on('change input', '.quantity .qty', function () {
    console.log('Fooobar2');
    const $this = $(this);
    const maxAttr = parseInt($this.attr('max'), 10) || 9999;
    let quantity = parseInt($this.val(), 10) || 1;

    if (quantity > maxAttr) {
      quantity = maxAttr;
      $this.val(quantity);
    }

    let add_to_cart_button = $this.parent().parent().find('.add_to_cart_button');
    add_to_cart_button.attr('data-quantity', quantity);
    add_to_cart_button.attr(
      'href',
      '?add-to-cart=' + add_to_cart_button.data('product_id') + '&quantity=' + quantity
    );
  });

  
  $('.product-small.product').on('change input', '.quantity .qty', function () {
    console.log('Fooobar');
    const $this = $(this);
    const maxAttr = parseInt($this.attr('max'), 10) || 9999;
    let quantity = parseInt($this.val(), 10) || 1;

    if (quantity > maxAttr) {
      quantity = maxAttr;
      $this.val(quantity);
    }

    let add_to_cart_button = $this.parent().parent().find('.add_to_cart_button');
    add_to_cart_button.attr('data-quantity', quantity);
    add_to_cart_button.attr(
      'href',
      '?add-to-cart=' + add_to_cart_button.data('product_id') + '&quantity=' + quantity
    );
  });

  // Trigger on Enter press
  $('.woocommerce .products').on('keypress', '.quantity .qty', function (e) {
    if ((e.which || e.keyCode) === 13) {
      $(this).parents('.product').find('.add_to_cart_button').trigger('click');
    }
  });
}